import React, { useState, useEffect } from 'react';
import { Select, Space, Typography, Spin } from 'antd';
import { dashboardApi } from '../../services/dashboardApi';
import { EditOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { Option } = Select;

const VariableSelector = ({ variable, value, onChange, onEdit }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // If variable already has options, use them
    if (variable.options && variable.options.length > 0) {
      const opts = variable.options.map(val => ({
        label: val,
        value: val
      }));
      
      if (variable.includeAll) {
        opts.unshift({ label: 'All', value: '__all__' });
      }
      
      setOptions(opts);
      
      // Set default value if not set
      if (!value && opts.length > 0) {
        onChange(opts[0].value);
      }
    } else if (variable.query) {
      // Otherwise load from API
      loadOptions();
    }
  }, [variable.query, variable.options]);

  const loadOptions = async () => {
    setLoading(true);
    try {
      let queryString = variable.query;
      if (typeof queryString === 'object' && queryString.query) {
        queryString = queryString.query;
      }
      
      const match = queryString?.match(/label_values\(([^)]+)\)/);
      
      if (match) {
        const args = match[1].split(',').map((s) => s.trim());
        const labelName = args.length > 1 ? args[1] : args[0];
        const response = await dashboardApi.getLabelValues(labelName);
        
        if (response.success && response.data?.values) {
          let opts = response.data.values.map(val => ({
            label: val,
            value: val
          }));

          if (variable.includeAll) {
            opts.unshift({ label: 'All', value: '__all__' });
          }

          setOptions(opts);
          
          if (!value && opts.length > 0) {
            onChange(opts[0].value);
          }
        }
      }
    } catch (error) {
      console.error('Failed to load variable options:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <Text style={{ fontWeight: 500, fontSize: '12px' }}>
        {variable.label || variable.name}:
      </Text>
      <Select
        value={value}
        onChange={onChange}
        style={{ minWidth: 200 }}
        loading={loading}
        placeholder={loading ? 'Loading...' : `Select ${variable.name}`}
        showSearch
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        mode={variable.multi ? 'multiple' : undefined}
        options={options}
      />
      {onEdit && (
        <EditOutlined 
          style={{ cursor: 'pointer', color: '#1890ff' }} 
          onClick={onEdit}
        />
      )}
    </div>
  );
};

export default VariableSelector;